import { useEffect } from "react";
import { useTolgee } from "@tolgee/react";
import { INTERFACE_TRANSLATION_LANGUAGES } from "../Constants/constantValues";

const useLanguagePreFill = (language, setLanguage, translationsLanguages) => {
  const tolgee = useTolgee(["language"]);

  useEffect(() => {
    if (language || !translationsLanguages || !translationsLanguages.length) return;
    const ifaceLang = INTERFACE_TRANSLATION_LANGUAGES.find(
      (l) => l.locale === tolgee.getLanguage()
    );
    if (!ifaceLang) return;
    const match = translationsLanguages.find((l) => l.name === ifaceLang.name);
    if (match) setLanguage(match.name);
  }, [translationsLanguages, tolgee]);
};

export default useLanguagePreFill;
